import { useLazyQuery } from '@apollo/client';
import { useCallback, useMemo } from 'react';

import { getServiceRequestByUCIIdQuery } from 'graphql-queries';

export class ServiceRequestByInteractionIdError extends Error {}

export const useGetServiceRequestByInteractionId = () => {
  const [executeQuery, { data, loading, error }] = useLazyQuery(
    getServiceRequestByUCIIdQuery
  );

  const fetchServiceRequest = useCallback(
    async (interactionId: string) => {
      const result = await executeQuery({
        variables: { uciId: interactionId },
      });

      return result.data?.serviceRequestByUCI ?? null;
    },
    [executeQuery]
  );

  const wrappedError = useMemo(
    () =>
      error ? new ServiceRequestByInteractionIdError(error.message) : undefined,
    [error]
  );

  return {
    fetchServiceRequest,
    serviceRequest: data?.serviceRequestByUCI ?? null,
    loading,
    error: wrappedError,
  };
};
